import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/security/auth.service';
import { UserService } from 'src/app/services/user.service';
import { jwtDecode } from 'jwt-decode';
import { MessageHandlerService } from 'src/app/services/message-handler.service';
import {LOGIN_PATH, NO_AUTHORIZE_USER, SSO_SIGN_IN_FAILED} from 'src/app/common/Constants';

@Component({
  selector: 'app-sso-authorize',
  templateUrl: './sso-authorize.component.html',
  styleUrls: ['./sso-authorize.component.scss'],
})
export class SsoAuthorizeComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private messageHandlerService: MessageHandlerService,
  ) {}

  ngOnInit(): void {
    // The backend's token-only link returns the tokens in the fragment. It is still used where the code flow is
    // not set up, and by a sign-in started before the switch.
    if (this.route.snapshot.fragment?.includes('access_token')) {
      this.completeTokenOnlySignIn();
      return;
    }
    this.authService.completeSsoSignIn().then(
      ({ accessToken, email }) => this.startSession(accessToken, email),
      (error) => {
        console.log('SSO sign-in did not complete: ', error);
        this.messageHandlerService.generateToastMessage('error', '', SSO_SIGN_IN_FAILED);
        this.router.navigate([LOGIN_PATH]);
      },
    );
  }

  private completeTokenOnlySignIn(): void {
    let access_token = '';
    let id_token = '';
    this.route.snapshot.fragment.split('&').forEach((e) => {
      const s = e.split('=');

      if (s.includes('access_token')) {
        access_token = s[1];
      }
      if (s.includes('id_token')) {
        id_token = s[1];
      }
    });

    const decodedToken: any = jwtDecode(id_token);
    this.startSession(access_token, decodedToken.email);
  }

  private startSession(accessToken: string, email: string): void {
    this.authService.setToken(accessToken);
    this.authService.initTokenRefresh();
    this.userService.userActive({ email }).subscribe((res) => {
      if (!res?.success) {
        this.messageHandlerService.generateToastMessage('error', '', NO_AUTHORIZE_USER);
      } else {
        this.authService.currentUserSubject.next(res.content);
      }
    });
    this.router.navigate(['/']);
  }

  ngOnDestroy(): void {}
}
